const RequiredAsterik = () => <span className="text-primary">*</span>;
export default RequiredAsterik;
